import { styled } from '@linaria/react';
import { Fragment, memo } from 'react';
import PopTopicCardSkeleton from '@fe-news/components/molecules/PopTopicCardSkeleton';
import TimelineSkeleton from '@fe-news/components/atoms/PopTopic/TimelineSkeleton';

const View = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  row-gap: 30px;
`;
const POP_TOPIC_DEFAULT_COUNT = 10;

type PopTopicInfiniteListSkeletonProps = {
  isTimeline?: boolean;
};

const PopTopicInfiniteListSkeleton: React.FC<PopTopicInfiniteListSkeletonProps> = ({ isTimeline = false }) => {
  return (
    <View>
      {Array.from({ length: POP_TOPIC_DEFAULT_COUNT })
        .fill(0)
        .map((_, index) => (
          <Fragment key={`pop_topic_card_skeleton_${index}`}>
            {!isTimeline && <PopTopicCardSkeleton />}
            {isTimeline && <TimelineSkeleton />}
          </Fragment>
        ))}
    </View>
  );
};

export default memo(PopTopicInfiniteListSkeleton);
